import { render, staticRenderFns } from "./pedidosTable.vue?vue&type=template&id=290816b2&"
import script from "./pedidosTable.vue?vue&type=script&lang=js&"
export * from "./pedidosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports